module.exports = __webpack_public_path__ + "img/65_11.1e1ed901.png";